import { useEffect, useRef } from "react";
import { useTranslation } from "@/hooks/useTranslation";

/**
 * Syncs cart.language_iso to the locale store exactly once on initial checkout load.
 * Cart language is the source of truth on entry — the storefront's selected
 * language was already persisted to cart.language_iso, so applying it here
 * keeps checkout aligned with the storefront. Subsequent in-session changes via
 * the checkout language selector are preserved (the hasSynced ref prevents
 * re-sync within the same session); on a fresh session the cart's language wins
 * again, which is what users expect when they switch language on the storefront.
 */
function useLanguageSync(languageIso: string | undefined | null) {
  const { changeLanguage } = useTranslation();
  const hasSynced = useRef(false);

  useEffect(() => {
    if (hasSynced.current || !languageIso) return;

    hasSynced.current = true;
    changeLanguage(languageIso);
  }, [languageIso, changeLanguage]);
}

export default useLanguageSync;
